module.exports = __webpack_public_path__ + "img/huib.919a3038.jpg";